import React from "react";
import { Alert, Form, Icon, Input, Button, Row, Col, Select } from "antd";

import get from "lodash/get";
import { connect } from "react-redux";

import { createLanguage, updateLanguage } from "../../api/requests";

import classes from "./SettingsLanguageForm.css";
import { logout } from "../../reducers/user/actions";
import { withNamespaces } from "react-i18next";

const languages = require("../../languages.json");

class SettingsLanguageForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      requestResult: {},
    };
  }

  handleSubmit = (e) => {
    e.preventDefault();

    this.props.form.validateFields(async (err, values) => {
      this.setState({ isSubmitted: true, requestResult: {} });

      if (!err) {
        this.setState({ isLoading: true });

        try {
          const data = { name: languages[values.language].name, code: values.language };

          if (this.props.language) {
            await updateLanguage({ ...this.props.language, ...data });
          } else {
            await createLanguage(data);
          }

          this.setState({
            isLoading: false,
            requestResult: {
              type: "success",
              message: this.props.i18n.t("Success"),
            },
          });

          setTimeout(() => {
            this.props.onSubmit(this.props.id);
          }, 1000);
        } catch (e) {
          if (get(e, "response.status") === 401) {
            this.props.logout();
            return;
          }

          this.setState({
            isLoading: false,
            requestResult: {
              type: "error",
              message: get(e, "response.data.message", this.props.i18n.t("Error")),
            },
          });

          if (get(e, "response.data.errors")) {
            const errors = {};
            Object.keys(get(e, "response.data.errors")).forEach(
              (errorFieldKey) => {
                errors[errorFieldKey] = {
                  value: values[errorFieldKey],
                  errors: get(e, `response.data.errors.${errorFieldKey}`).map(
                    (errorMessage) => new Error(errorMessage)
                  ),
                };
              }
            );

            this.props.form.setFields(errors);
          }
        }
      }
    });
  };

  render() {
    const { isLoading, requestResult } = this.state;
    const { getFieldDecorator } = this.props.form;

    let usedLanguageKeys = this.props.languages.map(item => item.code);

    if (this.props.language) {
      usedLanguageKeys = usedLanguageKeys.filter(item => item !== this.props.language.code)
    }

    const filteredLanguagesKeys = Object.keys(languages).filter(item => !usedLanguageKeys.includes(item));

    return (
      <div className={classes.wrapper}>
        <Form onSubmit={this.handleSubmit}>
          <h4 className="headline-default">
            {this.props.i18n.t("NamespaceSettingsLanguageForm:New Language")}
          </h4>

          <Row gutter={12}>
            <Col span={24}>
              <label>
                <b>{this.props.i18n.t("Language")}:</b>
                <Form.Item>
                  {getFieldDecorator("language", {
                    rules: [{ required: true, message: this.props.i18n.t("Required") }],
                    initialValue: get(this.props, "language.code", ""),
                  })(
                    <Select showSearch optionFilterProp="children">
                      {filteredLanguagesKeys.map((code) => (
                        <Select.Option key={code} value={code}>
                          <img
                            src={`https://flagcdn.com/16x12/${code}.png`}
                            alt={code}
                          />{" "}
                          {languages[code].name}
                        </Select.Option>
                      ))}
                    </Select>
                  )}
                </Form.Item>
              </label>
            </Col>
          </Row>

          {requestResult.type && (
            <Alert
              message={requestResult.message}
              type={requestResult.type}
              className={classes.submitResult}
            />
          )}

          <div className={classes.actionWrapper}>
            <Form.Item>
              <Button
                type="primary"
                size="large"
                htmlType="submit"
                className={classes.submitButton}
              >
                {this.props.i18n.t("Save")}
                {isLoading && <Icon type="loading" />}
              </Button>
              &nbsp; &nbsp;
            </Form.Item>

            <Button
              type="default"
              size="large"
              htmlType="button"
              className={classes.submitButton}
              onClick={this.props.onCancel}
            >
              {this.props.i18n.t("Cancel")}
            </Button>
          </div>
        </Form>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({});

const mapDispatchToProps = { logout };

export default Form.create({ name: "language" })(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withNamespaces()(SettingsLanguageForm))
);



// WEBPACK FOOTER //
// ./src/containers/SettingsLanguages/SettingsLanguageForm.js